"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnInlineActionsMenu = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = __importStar(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var Actions_1 = __importDefault(require("../../../gen-src/icons/Actions"));
var ActionsActive_1 = __importDefault(require("../../../gen-src/icons/ActionsActive"));
var ColumnDetailsDialog_1 = require("../ColumnDetails/ColumnDetailsDialog");
var RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
var ReRenderPlacePageContext_1 = require("../placePage/ReRenderPlacePageContext");
var ColumnActions;
(function (ColumnActions) {
    ColumnActions["Tags"] = "Tags";
    ColumnActions["Description"] = "Edit Description";
    ColumnActions["QualityWarning"] = "Quality Warning";
    ColumnActions["SensitiveLabels"] = "Edit Sensitivity Label";
})(ColumnActions || (ColumnActions = {}));
var noop = function () { return; };
var Spacing = widgets_1.TabStyles.Spacing;
var ActionsMenuCellStyle = {
    padding: Spacing.SmallSpace,
    cursor: 'pointer',
    verticalAlign: 'middle',
    minWidth: 0,
    height: 24,
    width: 24,
};
var ListMenuStyle = {
    fontWeight: 'normal',
    top: '-1px'
};
function ActionStatusIcon(props) {
    if (props.hover) {
        return React.createElement(ActionsActive_1.default, null);
    }
    else {
        return React.createElement(Actions_1.default, null);
    }
}
function ColumnInlineActionsMenu(props) {
    var _a = React.useState(null), buttonEl = _a[0], setButtonEl = _a[1];
    var _b = React.useState(''), actionItem = _b[0], setActionItem = _b[1];
    var _c = React.useState(false), isMenuShowing = _c[0], setIsMenuShowing = _c[1];
    var _d = React.useState(false), isDialogShowing = _d[0], setIsDialogShowing = _d[1];
    var rerender = React.useContext(ReRenderPlacePageContext_1.ReRenderPlacePageContext).rerender;
    var _e = React.useContext(data_catalog_shared_1.UIActionsContext), renderDataQualityDialog = _e.renderDataQualityDialog, renderSensitiveLabelsDialog = _e.renderSensitiveLabelsDialog;
    var sensitiveLabelsEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).sensitiveLabelsEnabled;
    var testId = 'inline-column-actions';
    var columnId = props.columnId, columnLuid = props.columnLuid, columnName = props.columnName, columnRemoteType = props.columnRemoteType, tableVizportalId = props.tableVizportalId, canUpdate = props.canUpdate;
    if (!columnId) {
        return null;
    }
    var columnActionItems = [
        {
            value: ColumnActions.Tags,
            displayValue: Localize_1.Messages.TagsAction(),
            disabled: !canUpdate,
        },
        {
            value: ColumnActions.Description,
            displayValue: Localize_1.Messages.EditDescriptionAction(),
            disabled: !canUpdate,
        },
        {
            value: ColumnActions.QualityWarning,
            displayValue: Localize_1.Messages.DataQualityWarningAction(),
            disabled: !canUpdate || !columnLuid,
        }
    ];
    var sensitiveLabelActionItem = [{
            value: ColumnActions.SensitiveLabels,
            displayValue: Localize_1.Messages.SensitiveLabelAction(),
            disabled: !canUpdate || !columnLuid,
        }];
    return (React.createElement(React.Fragment, null,
        React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, title: Localize_1.Messages.Actions(), testId: testId, getContent: function (s) { return React.createElement(ActionStatusIcon, { hover: s.hover || s.active || false }); }, buttonRef: setButtonEl, onClick: function () { return setIsMenuShowing(!isMenuShowing); }, style: ActionsMenuCellStyle, disabled: !canUpdate, tabIndex: -1 }),
        isMenuShowing && React.createElement(widgets_1.FlyoutListMenuWidget, { anchorEl: buttonEl, menuItemInfos: sensitiveLabelsEnabled ? columnActionItems.concat(sensitiveLabelActionItem) : columnActionItems, testId: testId, toggleEl: buttonEl, menuStyle: ListMenuStyle, onSelect: function (value) {
                if (value === ColumnActions.QualityWarning && columnLuid) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                    renderDataQualityDialog({
                        content: {
                            contentId: columnLuid,
                            contentName: columnName,
                            contentType: 'column',
                            contentIcon: (React.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: columnRemoteType })),
                        },
                        dismiss: function () {
                            rerender();
                        },
                    }).catch(function (_) { return; });
                }
                else if (value === ColumnActions.SensitiveLabels && columnLuid) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                    renderSensitiveLabelsDialog({
                        content: {
                            contentId: columnLuid,
                            contentName: columnName,
                            contentType: 'column',
                            contentIcon: (React.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: columnRemoteType })),
                        },
                        dismiss: function () {
                            rerender();
                        },
                    }).catch(function (_) { return; });
                }
                else {
                    setIsDialogShowing(true);
                    setActionItem(value);
                    setIsMenuShowing(false);
                }
            }, requestCloseAll: function () {
                setIsMenuShowing(false);
            } }),
        isDialogShowing &&
            (actionItem === ColumnActions.Tags || actionItem === ColumnActions.Description) &&
            React.createElement(ColumnDetailsDialog_1.ColumnDetailsDialogQueryWrapper, { columnId: columnId, tableVizportalId: tableVizportalId, onClose: function () { setIsDialogShowing(false); }, afterDescriptionChange: noop })));
}
exports.ColumnInlineActionsMenu = ColumnInlineActionsMenu;
//# sourceMappingURL=ColumnInlineActionsMenu.js.map